module.exports = new __parcel__URL__("editor-ai-opt-in-banner.523b2454.svg").toString();